export default __webpack_public_path__ + "static/media/ReliableDelivery.44a3dc49.svg";